module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('cIndex', {
    ref: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "setpassword-content"
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.ruleForm2.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "oldPassword", $$v)
      },
      expression: "ruleForm2.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "pass", $$v)
      },
      expression: "ruleForm2.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "再次输入密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "setpassword-button"
  }, [_c('a', {
    staticClass: "fanhui",
    attrs: {
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.back(-1)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('a', {
    staticClass: "submits",
    attrs: {
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm2')
      }
    }
  }, [_vm._v("提交")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1076eb83","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setpassword.vue
// module id = 746
// module chunks = 1